function Graphics(context) {
  this.context = context;
}
var p = Graphics.prototype;
p.resizeCanvas = function () {
  this.context.canvas.width = window.innerWidth;
  this.context.canvas.height = window.innerHeight;
};
p.clear = function () {
  this.save();
  this.context.setTransform(1, 0, 0, 1, 0, 0);
  this.context.clearRect(0, 0, 9000, 9000);
  this.restore();
};
p.fillStyle = function (s) {
  if (s) {
    this.context.fillStyle = s;
  } else {
    return s;
  }
};
p.strokeStyle = function (s) {
  if (s) {
    this.context.strokeStyle = s;
  } else {
    return s;
  }
};
p.font = function (font) {
  this.context.font = font;
};
p.circle = function (x, y, radius) {
  this.context.beginPath();
  this.context.arc(x, y, radius, 0, Math.PI * 2, true);
  this.context.closePath();
};
p.rectangle = function (x, y, w, h) {
  this.context.rect(x, y, w, h);
};
p.polygon = function (points) {
  this.context.beginPath();
  if (points.length > 0) {
    this.context.moveTo(points[0].x, points[0].y);
    for (var i = 1; i < points.length; i++) {
      this.context.lineTo(points[i].x, points[i].y);
    }
  }
  this.context.closePath();
};
p.strokePolygon = function (points) {
  this.polygon(points);
  this.context.stroke();
};
p.fillPolygon = function (points) {
  this.polygon(points);
  this.context.fill();
};
p.strokeRectangle = function (x, y, w, h) {
  this.context.strokeRect(x, y, w, h);
};
p.fillRectangle = function (x, y, w, h) {
  this.context.fillRect(x, y, w, h);
};
p.strokeCircle = function (x, y, radius) {
  this.circle(x, y, radius);
  this.context.stroke();
};
p.fillCircle = function (x, y, radius) {
  this.circle(x, y, radius);
  this.context.fill();
};
p.fillLoading = function (x, y, radius, fraction) {
  var c = this.context;
  var abegin = (fraction * 360 - 90) * (Math.PI / 180);
  var aend = (0 - 90) * (Math.PI / 180);

  c.beginPath();
  c.moveTo(x, y);
  c.lineTo(x + Math.cos(abegin) * radius, y + Math.sin(abegin) * radius);
  c.arc(x, y, radius, abegin, aend, false);
  c.lineTo(x, y);
  c.closePath();
  c.fill();
};
p.shadow = function (color, blur, offx, offy, fn) {
  this.context.shadowColor = color;
  this.context.shadowBlur = blur;
  this.context.shadowOffsetX = offx;
  this.context.shadowOffsetY = offy;
  fn();
  this.context.shadowColor = "";
  this.context.shadowBlur = 0;
  this.context.shadowOffsetX = 0;
  this.context.shadowOffsetY = 0;
};
p.line = function (x1, y1, x2, y2) {
  this.context.beginPath();
  this.context.moveTo(x1, y1);
  this.context.lineTo(x2, y2);
  this.context.closePath();
};
p.strokeLine = function (x1, y1, x2, y2) {
  this.line(x1, y1, x2, y2);
  this.context.stroke();
};

p.translate = function (x, y, translated) {
  this.save();
  this.context.translate(x, y);
  translated();
  this.restore();
};
p.rotate = function (x, y, r, rotated) {
  this.save();
  this.context.translate(x, y);
  this.context.rotate(r);
  this.context.translate(-x, -y);
  rotated();
  this.restore();
};
p.scale = function (x, y, sx, sy, scaled) {
  this.save();
  this.context.translate(x, y);
  this.context.scale(sx, sy);
  this.context.translate(-x, -y);
  scaled();
  this.restore();
};
p.scalerotate = function (x, y, sx, sy, r, rotatedscaled) {
  this.save();
  this.context.translate(x, y);
  this.context.rotate(r);
  this.context.scale(sx, sy);
  this.context.translate(-x, -y);
  rotatedscaled();
  this.restore();
};
p.drawImage = function (img, sx, sy, sw, sh, dx, dy, dw, dh) {
  if (img) {
    this.context.drawImage.apply(this.context, arguments);
  }
};
p.drawCenteredImage = function (img, x, y) {
  if (img) {
    this.context.drawImage(img, x - img.width / 2, y - img.height / 2);
  }
};
p.fillCenteredText = function (text, x, y) {
  var size = this.context.measureText(text);
  this.context.fillText(text, x - size.width / 2, y);
};
p.fillText = function (text, x, y) {
  this.context.fillText(text, x, y);
};
p.save = function () {
  if (!this._depth) {
    this._depth = 0;
  }
  this._depth++;
  this.context.save();
};
p.restore = function () {
  if (this._depth <= 0) {
    console.log("NOES");
    throw "NOES";
  }
  this.context.restore();
  this._depth--;
};
export default Graphics;
